import { Component, Inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { AttributesSelectionData } from './models/attributes-selection-data';
import { AttributesSelectionResult } from './models/attributes-selection-result';

@Component({
    selector: 'app-attributes-selection',
    imports: [MatSelectModule, MatFormFieldModule, FormsModule, MatCardModule, MatButtonModule],
    templateUrl: './attributes-selection.component.html',
    styleUrl: './attributes-selection.component.scss'
})
export class AttributesSelectionComponent {
    @ViewChild('attributeselect') attributeselect: MatSelect;

    public result = new AttributesSelectionResult();

    constructor(
        public dialogRef: MatDialogRef<AttributesSelectionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AttributesSelectionData
    ) {}

    ngAfterViewInit() {
        this.attributeselect.openedChange.subscribe((opened) => {
            if (opened) {
                this.attributeselect.panel.nativeElement.addEventListener('mouseleave', () => {
                    this.attributeselect.close();
                });
            }
        });
    }

    onCancel() {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.result);
    }
}
